import React from "react";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import {
  OcDatePicker,
  OcDatePickerProps,
} from "oc/components/date-picker/date-picker";
import { getDateFormatByLocale } from "oc/utils";

type OcDatePickerFormikProps = Partial<OcDatePickerProps> & {
  name: string;
};

export const OcDatePickerFormik: React.FC<OcDatePickerFormikProps> = ({
  name,
  ...props
}) => {
  const { i18n } = useTranslation();
  const [field, meta, helper] = useField(name);

  return (
    <OcDatePicker
      onChange={(date) => helper.setValue(date)}
      onFocus={() => {
        helper.setError(undefined);
      }}
      value={field.value}
      error={Boolean(meta.error)}
      helperText={meta.error}
      id={name}
      format={getDateFormatByLocale(i18n.language)}
      {...props}
    />
  );
};
